import { combineReducers } from "redux";
import { Reducer } from "redux";
import { AppState, HrState, MasterState, OperationsState, PermissionsState, SalesState } from "./types";

// reducers
import userReducer from "./reducers/userReducer";
import loaderReducer from "./reducers/loaderReducer";
import branchReducer from "./reducers/master/branchReducer";
import dropdownReducer from "./reducers/dropdownReducer";
import bankReducer from "./reducers/master/bankReducer";
import modeReducer from "./reducers/master/modeReducer";
import departmentReducer from "./reducers/master/departmentReducer";
import contentReducer from "./reducers/master/contentReducer";
import packageTypeReducer from "./reducers/master/packageTypeReducer";
import vehicleTypeReducer from "./reducers/master/vehicleTypeReducer";
import driverReducer from "./reducers/master/driverReducer";
import vehicleReducer from "./reducers/master/vehicleReducer";
import apiReducer from "./reducers/apiReducer";
import spinnerDataReducer from "./reducers/spinnerDataReducer";
import roleReducer from "./reducers/master/roleReducer";
import leadReducer from "./reducers/sales/leadReducer";
import pincodeReducer from "./reducers/master/pincodeReducer";
import stateReducer from "./reducers/master/stateReducer";
import districtReducer from "./reducers/master/districtReducer";
import zoneReducer from "./reducers/master/zoneReducer";
import hubReducer from "./reducers/master/hubReducer";
import activityReducer from "./reducers/sales/activityReducer";
import customerReducer from "./reducers/master/customerReducer";
import tatReducer from "./reducers/master/tatReducer";
import rateReducer from "./reducers/master/rateReducer";
import warehouseReducer from "./reducers/master/warehouseReducer";
import permissionReducer from "./reducers/permissions/permissionReducer";
import vendorReducer from "./reducers/master/vendorReducer";
import vendorPincodeReducer from "./reducers/master/vendorPincodeReducer";
import departmentPermissionReducer from "./reducers/permissions/departmentPermissionReducer";
import pickupRequestReducer from "./reducers/operations/pickupRequestReducer";
import departmentSectionReducer from "./reducers/permissions/departmentSectionReducer";
import permissionRoleReducer from "./reducers/permissions/permissionRoleReducer";
import sectionReducer from "./reducers/permissions/sectionReducer";
import taReducer from "./reducers/master/taReducer";
import dashboardPickupRequestReducer from "./reducers/operations/pickupRequestDashoboardReducer";
import pickupRequestSheetReducer from "./reducers/operations/pickupRequestSheetReducer";
import myActivityReducer from "./reducers/sales/myActivityReducer";
import myLeaveReducer from "./reducers/hr/myLeavesReducer";
import attendanceReducer from "./reducers/hr/attendanceReducer";
import hrActivityReducer from "./reducers/hr/activityReducer";
import leaveReducer from "./reducers/hr/hrReducer";
import salesExpenseReducer from "./reducers/sales/salesExpenseReducer";
import mySalesExpenseReducer from "./reducers/sales/mySalesExpenseReducer";
import { UserActions } from "./actionTypes/userActionTypes";
import myLeadReducer from "./reducers/sales/myLeadReducer";
import siteConfigReducer from "./reducers/siteConfigReducer";
import awbReducer from "./reducers/operations/AwbReducer";
import CustomerUserReducer from "./reducers/customerUserReducer";
import areaCodeReducer from "./reducers/master/areaCodeReducer";
import vasTypeReducer from "./reducers/master/vasTypeReducer";
import vasRateReducer from "./reducers/master/vasRateReducer";
import vasRuleReducer from "./reducers/master/vasRuleReducer";
import valueAddedServiceReducer from "./reducers/master/valueAddedServiceReducer";
import customerRateReducer from "./reducers/master/customerRateReducer";
import customerVasReducer from "./reducers/master/customerVasReducer";
import billingReducer from "./reducers/master/billingReducer";

const masterReducers: Reducer<MasterState> = combineReducers({
  branch: branchReducer,
  bank: bankReducer,
  mode: modeReducer,
  department: departmentReducer,
  content: contentReducer,
  packageType: packageTypeReducer,
  vehicleType: vehicleTypeReducer,
  driver: driverReducer,
  vehicle: vehicleReducer,
  role: roleReducer,
  pincode: pincodeReducer,
  state: stateReducer,
  district: districtReducer,
  zone: zoneReducer,
  areaCode: areaCodeReducer,
  hub: hubReducer,
  customer: customerReducer,
  tat: tatReducer,
  rate: rateReducer,
  warehouse: warehouseReducer,
  vendor: vendorReducer,
  vendorPincode: vendorPincodeReducer,
  ta: taReducer,
  vasType: vasTypeReducer,
  vasRate: vasRateReducer,
  vasRule: vasRuleReducer,
  valueAddedService: valueAddedServiceReducer,
  customerRate: customerRateReducer,
  customerVas: customerVasReducer,
  billing: billingReducer,
});

const salesReducers: Reducer<SalesState> = combineReducers({
  lead: leadReducer,
  myLead: myLeadReducer,
  activity: activityReducer,
  myActivity: myActivityReducer,
  expense: salesExpenseReducer,
  myExpense: mySalesExpenseReducer,
});

const permissionsReducers: Reducer<PermissionsState> = combineReducers({
  permission: permissionReducer,
  section: sectionReducer,
  departmentPermission: departmentPermissionReducer,
  permissionRole: permissionRoleReducer,
  departmentSection: departmentSectionReducer,
});

const operationsReducers: Reducer<OperationsState> = combineReducers({
  pickupRequest: pickupRequestReducer,
  pickupDashboard: dashboardPickupRequestReducer,
  pickupRequestSheet: pickupRequestSheetReducer,
  awb: awbReducer,
});

const hrReducers: Reducer<HrState> = combineReducers({
  attendance: attendanceReducer,
  hrActivity: hrActivityReducer,
  leaves: leaveReducer,
  myLeaves: myLeaveReducer,
});

const appReducers: Reducer<AppState> = combineReducers({
  user: userReducer,
  loader: loaderReducer,
  dropdown: dropdownReducer,
  apiStatus: apiReducer,
  spinnerData: spinnerDataReducer,
  siteThemeConfig: siteConfigReducer,
  master: masterReducers,
  sales: salesReducers,
  hr: hrReducers,
  permissions: permissionsReducers,
  operations: operationsReducers,
  customer: customerReducer,
  customerUser:CustomerUserReducer,
});

// for reseting root reducer on logout
const rootReducer = (state: any, action: any) => {
  if (action.type === UserActions.RESET_ALL_DATA) {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducer;
